import { create } from 'zustand';

interface Filters {
  region: string | null;
  minScore: number;
  source: string | null;
  skills: string[];
}

interface AppState {
  sidebarOpen: boolean;
  filters: Filters;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  setFilter: <K extends keyof Filters>(key: K, value: Filters[K]) => void;
  resetFilters: () => void;
}

const defaultFilters: Filters = {
  region: null,
  minScore: 0,
  source: null,
  skills: []
};

export const useAppStore = create<AppState>((set) => ({
  sidebarOpen: true,
  filters: { ...defaultFilters },
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  setFilter: (key, value) => set((s) => ({ filters: { ...s.filters, [key]: value } })),
  resetFilters: () => set({ filters: { ...defaultFilters } })
}));
